import { AppDistribution } from "@/types/common.types.ts";

// Статья /help/article/mcp-connection собирается только для Skailer: в других дистрибутивах ссылка вела бы на 404.
export function getMcpServerUrl(): string | undefined {
  if (import.meta.env.VITE_APP_DISTRIBUTION !== AppDistribution.skailer) return undefined;
  return import.meta.env.VITE_MCP_URL || undefined;
}
